export default class LlmMessagePrefixer {
    static prefixMessageAsPlayer(llmMessage, playerName) {
        return `${playerName} (speler): ${llmMessage} `;
    }

    static getPlayerMessagePrefix(playerName) {
        return `${playerName} (speler): `;
    }
}